import { render, staticRenderFns } from "./local-video-modal.vue?vue&type=template&id=187ddcd4&scoped=true"
import script from "./local-video-modal.vue?vue&type=script&lang=js"
export * from "./local-video-modal.vue?vue&type=script&lang=js"
import style0 from "./local-video-modal.vue?vue&type=style&index=0&id=187ddcd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ddcd4",
  null
  
)

export default component.exports